import React, { Component } from "react";
import ProductsList from './components/ProductsList.js'
// import './script.js'

export default class Search_result extends Component {
	render() {
		return (
		<div id="Search">
        <ProductsList/>
		</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Search_result/Search_result.js